/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AllowedGroundingFiles
 */
export interface AllowedGroundingFiles {
    /**
     * 
     * @type {number}
     * @memberof AllowedGroundingFiles
     */
    readonly maxSizeInBytesPerFile: number;
    /**
     * 
     * @type {number}
     * @memberof AllowedGroundingFiles
     */
    readonly totalSizeInBytes: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AllowedGroundingFiles
     */
    readonly allowedFileExtensions: Array<string>;
}

/**
 * Check if a given object implements the AllowedGroundingFiles interface.
 */
export function instanceOfAllowedGroundingFiles(value: object): value is AllowedGroundingFiles {
    if (!('maxSizeInBytesPerFile' in value) || value['maxSizeInBytesPerFile'] === undefined) return false;
    if (!('totalSizeInBytes' in value) || value['totalSizeInBytes'] === undefined) return false;
    if (!('allowedFileExtensions' in value) || value['allowedFileExtensions'] === undefined) return false;
    return true;
}

export function AllowedGroundingFilesFromJSON(json: any): AllowedGroundingFiles {
    return AllowedGroundingFilesFromJSONTyped(json, false);
}

export function AllowedGroundingFilesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllowedGroundingFiles {
    if (json == null) {
        return json;
    }
    return {
        
        'maxSizeInBytesPerFile': json['maxSizeInBytesPerFile'],
        'totalSizeInBytes': json['totalSizeInBytes'],
        'allowedFileExtensions': json['allowedFileExtensions'],
    };
}

export function AllowedGroundingFilesToJSON(json: any): AllowedGroundingFiles {
    return AllowedGroundingFilesToJSONTyped(json, false);
}

export function AllowedGroundingFilesToJSONTyped(value?: Omit<AllowedGroundingFiles, 'maxSizeInBytesPerFile'|'totalSizeInBytes'|'allowedFileExtensions'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

